import { useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import type { TelegramLoginData } from '../../types/telegram';

interface TelegramLoginButtonProps {
  botUsername: string;
  onAuth: (data: TelegramLoginData) => void;
}

const WIDGET_SCRIPT_URL = 'https://telegram.org/js/telegram-widget.js?22';
const CALLBACK_NAME = 'onTelegramAuth';

export default function TelegramLoginButton({
  botUsername,
  onAuth,
}: TelegramLoginButtonProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const onAuthRef = useRef(onAuth);

  useEffect(() => {
    onAuthRef.current = onAuth;
  }, [onAuth]);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return undefined;
    }

    const globals = window as unknown as Record<string, unknown>;
    globals[CALLBACK_NAME] = (data: TelegramLoginData) => {
      onAuthRef.current(data);
    };

    const script = document.createElement('script');
    script.src = WIDGET_SCRIPT_URL;
    script.async = true;
    script.setAttribute('data-telegram-login', botUsername);
    script.setAttribute('data-size', 'large');
    script.setAttribute('data-userpic', 'false');
    script.setAttribute('data-request-access', 'write');
    script.setAttribute('data-onauth', `${CALLBACK_NAME}(user)`);
    container.appendChild(script);

    return () => {
      delete globals[CALLBACK_NAME];
      container.replaceChildren();
    };
  }, [botUsername]);

  return <Box ref={containerRef} />;
}
